export default __webpack_public_path__ + "6863b3024359f319c35361a08a13ffb7.png";